module.exports = __webpack_public_path__ + "assets/src/style/img/footer-provincie-drenthe.png?fae6e1335bb0c262196317eeade75b9c";